import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  scoreList: {
    flexDirection: "row",
    alignSelf: "center",
  },
  rangePadding: {
    paddingTop: "4vw",
  },
  descriptionContainer: {
    marginTop: "2vmin",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  score: {
    borderColor: "$option_card_outline",
    backgroundColor: "$option_card",
    borderWidth: 0,
    justifyContent: "center",
    alignContent: "center",
    marginHorizontal: "0.5vw",
    width: "5.3vw",
    height: "5.3vw",
  },
  scoreLarge: {
    marginHorizontal: "2.5vw",
    width: "9.3vw",
    height: "6.3vw",
  },
  scoreSelected: {
    backgroundColor: "$selected_option",
  },
  scoreLabel: {
    alignSelf: "center",
    fontWeight: "bold",
    fontSize: "$nps_score_size",
    fontFamily: "$nps_score_style",
    color: "$option_text",
  },
  "@media (max-width: 700)": {
    scoreLabel: {
      fontSize: "$h4",
    },
  },
  scoreLabelSelected: {
    color: "$survey_card",
  },
  description: {
    fontSize: "$nps_description_size",
    fontFamily: "$nps_description_style",
    textAlign: "right",
    width: "15vmax",
    color: "$help_text",
  },
  image: {
    position: "absolute",
    backgroundColor: "$survey_card",
    padding: "0.7vw",
    marginTop: "-5.5vw",
  },
});
